const getEnvVar = (key: string, fallback?: string): string => {
  const value = import.meta.env[key] ?? fallback;
  if (value === undefined) {
    throw new Error(`Nedostaje env varijabla: ${key}`);
  }
  return value;
};

export const env = {
  apiBaseUrl: getEnvVar('VITE_API_BASE_URL', 'http://backend.momcilo.docker.localhost'),
  wsUrl: getEnvVar('VITE_WS_URL', 'http://backend.momcilo.docker.localhost'),
  environment: getEnvVar('VITE_ENV', 'development'),
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
